import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Grid } from "@material-ui/core";
import { FormUpdatePassword, DynamicBG } from "~/components/blocks";
import { Margin, Title, Text, Button } from "~/components/elements";
import { TitleHolder, ButtonHolder } from "./styles";
import { scrollTop, parentScrollTop } from "~/utils/tools";
import history from "~/routes/history";
import { useSelector, useDispatch } from "react-redux";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import { Creators as AccountActions } from "~/store/modules/account/actions";

import isMobile from "~/hooks/isMobile";

export default function UpdatePassword() {
  const dispatch = useDispatch();
  const mobile = isMobile();
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const success = useSelector((state) => state?.account?.password?.success);

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    dispatch(AccountActions.resetSendPassword());
    scrollTop();
    parentScrollTop();
  }, [dispatch]);

  return (
    <motion.div
      variants={animations}
      className="single"
      initial="exit"
      animate="enter"
      exit="exit"
    >
      <DynamicBG content={true}>
        <Grid container>
          <TitleHolder success={success}>
            <Margin pt={mobile ? 6 : 12} mb={1}>
              <Title as="1" levelDesktop="3" level="4">
                {success ? "Tu contraseña ha sido actualizada" : "Actualiza tu contraseña"}
              </Title>
            </Margin>
            <Margin pb={mobile ? 9 : 5}>
              <Text primary={false} level={mobile ? "2" : "1"}>
                {success
                  ? `Por razones de seguridad, enviamos un correo electrónico a tu cuenta confirmando este cambio.`
                  : `Actualiza y confirma tu nueva contraseña para actualizar el acceso a tu cuenta.`}
              </Text>
            </Margin>
          </TitleHolder>
          {success ? (
            <ButtonHolder>
              <Button
                color="primary"
                onClick={() => {
                  dispatch(AuthenticationActions.purgeAuthentication());
                  history.push("/login");
                }}
              >
                CONTINUAR
              </Button>
            </ButtonHolder>
          ) : (
            <FormUpdatePassword />
          )}
        </Grid>
      </DynamicBG>
    </motion.div>
  );
}
